@use "variables" as *;

.results {
  color: $content-secondary-color;
}

.noResultsWrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: $spacing-6;
  text-align: center;
}
